export default "__VITE_ASSET__18095101__"